import type {
  ModalPipeline,
  ModalVelocityRequest,
  ModalVelocityResponse,
} from './adminTypes';
import { createFetchCache } from './createFetchCache';

export const VELOCITY_BAND = { f_min: 20, f_max: 200, df: 1 } as const;

const cache = createFetchCache<string, ModalVelocityResponse>({
  sig: (signature) => signature,
});

export function velocitySig(
  request: ModalVelocityRequest,
  pipeline: ModalPipeline | undefined,
): string {
  return JSON.stringify({ request, pipeline: pipeline ?? null });
}

export function getCachedVelocity(signature: string): ModalVelocityResponse | null {
  return cache.getCached(signature) ?? null;
}

export function fetchVelocity(
  signature: string,
  fetcher: () => Promise<ModalVelocityResponse>,
): Promise<ModalVelocityResponse> {
  return cache.fetch(signature, fetcher);
}

export function primeCachedVelocity(
  signature: string,
  response: ModalVelocityResponse,
): void {
  cache.prime(signature, response);
}

export function clearVelocityCache(): void {
  cache.clear();
}
